<template>
  <div class="popup">
    <div class="flex flex-between">
      <h2>Orçamento</h2>
      <a href="#" @click="$emit('close')" onclick="return false">
        <img src="../assets/close.webp" >
      </a>
    </div>
    <p style="font-weight: bold">{{ atual.modelo }} - {{atual.tamanho}} - {{ atual.ladrilho }}</p>
    <form action="" @submit.prevent="Submit">
      <div class="flex">
        <div class="col">
          <label for="">
            Nome
          </label>
          <input type="text" required class="form-control" v-model="form.nome">
        </div>
        <div class="col">
          <label for="">
            Sobrenome
          </label>
          <input type="text" required v-model="form.sobrenome">
        </div>
      </div>
      <div class="flex">
        <div class="col">
          <label for="">
            Email
          </label>
          <input type="email" required v-model="form.email">
        </div>
        <div class="col">
          <label for="">
            Telefone celular
          </label>
          <input type="text"  v-mask="'(##) #####-####'" v-model="form.telefone">
        </div>
      </div>
      <div class="flex">
        <div class="col">
          <label for="">
            Área (m²) ou quantidade
          </label>
          <input type="number" v-model="form.area">
        </div>
        <div class="col">
        </div>
      </div>
      <div class="flex">
        <div class="col">
          <label for="">
            Mensagem
          </label>
          <textarea type="text" rows="10" v-model="form.mensagem"></textarea>
        </div>
      </div>
      <div class="flex flex-center">
        <button type="submit">{{!send ? 'Enviar' : 'Enviando...'}}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";

export default {
  name: "Orcamento",
  props: ['atual'],
  mounted() {
    //this.download();
  },
  data() {
    return {
      apíURL: process.env.VUE_API_ORCAMENTO,
      send :false,
      form: {
        nome : '',
        sobrenome: '',
        email: '',
        telefone: '',
        area:'',
        mensagem:'',
        pdf:'',
      }
    }
  },
  methods: {
    async download () {
      let canvas = await html2canvas(document.querySelector('#pdf'), {imageTimeout: 6000, useCORS: true});
      let img = canvas.toDataURL('image/png')
      let pdf = new jsPDF('portrait', 'mm', 'a4')
      pdf.addImage(img, 'JPEG', 5, 5, 200, 287);
      //pdf.save();
      return img;
    },

    Submit() {
      this.send = true;

      let form_data = new FormData;

      for (const [key, value] of Object.entries(this.form)) {
        form_data.append(key, value);
      }

      axios.post("https://ladrilhobrimperial.com.br/wp-json/wp/v3/orcamento", form_data).then((x) => {

      });
      form_data.append('nome', this.form.nome);
      form_data.append('sobrenome', this.form.sobrenome);
      form_data.append('email', this.form.email);
      form_data.append('telefone', this.form.telefone);
      form_data.append('area', this.form.area);
      form_data.append('mensagem', this.form.mensagem);
      this.download().then((y) => {
        form_data.append('img', y);
        axios.post("https://ladrilhobrimperial.com.br/wp-json/wp/v3/orcamento", form_data).then((x) => {
          alert('Enviado com sucesso');
          this.$emit('close');
          this.send = false;
        });
      });
      return false;
    }
  }
}
</script>

<style scoped>
  input, textarea {
    height: 40px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 4px;
    padding: 8px;
    font-size: 16px;
    box-sizing: border-box;
    width: 100%;
    display: block;
    border: none;
    border: 1px solid gray;
  }

  .flex-center {
    justify-content: center;
  }

  button:not(.vs__clear) {
    padding: 10px 26px;
    cursor: pointer;
    background-color: #6495ed;
    color: #fff;
    margin-top: 20px;
    font-size: 18px;
    appearance: none;
    border: none;
    border-radius: 4px;
  }

  textarea {
    min-height: 80px;
  }

  form {
    margin-top: 42px;
  }

  .flex-between {
    align-items: center;
    justify-content: space-between;
  }

  .flex-between img {
    max-width: 30px;
    height: auto;
  }

  .flex {
    gap: 20px;
    margin-top: 12px;
  }

  .popup {
    padding: 40px;
    background-color: white;
    min-width: 700px;
  }
</style>